export const verificarMembresia = (usuario) => {

    if (usuario.fechaMembresia && usuario.fechaMembresia > new Date().getTime()) {
        return true
    } else {
        return false
    }
}